module.exports = __webpack_public_path__ + "static/story1-small-thumbnails-100x100-7314bc468f79ab63e51830b1f37cbc8f.jpg";